import { z } from "zod";

// Body of POST /api/partners/:id/onboarding — partner-admin onboarding task
// creation. Tighter than the legacy onboardingTaskCreateSchema (in
// types/domain.ts) because the worker route already carries partner_id in
// the path and the legacy admin-side UI only asks for title +
// assigned_to_partner; description/due_date/status are set elsewhere.
export const partnerOnboardingTaskCreateSchema = z.object({
  title: z.string().trim().min(1).max(200),
  assigned_to_partner: z.boolean().default(false),
});

export type PartnerOnboardingTaskCreateInput = z.infer<
  typeof partnerOnboardingTaskCreateSchema
>;

// Body of PATCH /api/partners/:id/onboarding/:taskId — done toggle.
export const partnerOnboardingTaskToggleSchema = z.object({
  done: z.boolean(),
});

export type PartnerOnboardingTaskToggleInput = z.infer<
  typeof partnerOnboardingTaskToggleSchema
>;
